import { gql } from '@apollo/client';

export default gql`
  fragment OrganizationBilling on Organization {
    id
    planTier
    periodEndAt
    trialEndAt
    isTrialEnded
    isTrialEndingSoon
    isLocked
    billingStatus
  }
`;
